import modalStore from 'shared/ui/Modal/store/modalStore'
import { type ActionItem } from 'shared/ui'
import type { UrlShortener } from 'entities/ShortLink/model/UrlShortener'
import { type IResponseCustomDomain } from 'entities/ShortLink'
import { VerifyCustomDomainModalContent } from 'pages/settings/pages/urlShortener/ui/VerifyCustomDomainModalContent/VerifyCustomDomainModalContent'
import { VerifyCustomDomainModalAction } from 'pages/settings/pages/urlShortener/ui/VerifyCustomDomainModalAction/VerifyCustomDomainModalAction'
import type { UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'

export const editCustomDomain = (
  store: UrlShortenerModalStore,
  urlShortener?: UrlShortener | IResponseCustomDomain
): ActionItem => {
  const onEdit = () => {
    if (urlShortener) {
      store.setDomainName(urlShortener.domain)
      store.setFallbackUrl(urlShortener.fallback_url ?? '')
      store.setUrlItem(urlShortener)
    }

    modalStore.addModal({
      id: store.idModal,
      title: 'Add custom domain',
      width: 480,
      onClose: () => store.closeModal(),
      showCloseButton: false,
      ModalContent: () => <VerifyCustomDomainModalContent store={store} />,
      ModalActions: () => <VerifyCustomDomainModalAction store={store} />,
    })
  }

  return {
    icon: 'edit',
    text: 'Edit',
    onAction: onEdit,
  }
}
